import {Pipe, PipeTransform} from '@angular/core';
import {Race} from "@model";

@Pipe({
  name: 'raceAltitudeFormat'
})
export class RaceAltitudeFormatPipe implements PipeTransform {

  transform(race: Race | undefined): string | undefined {
    return this.getRaceLength(race);
  }

  getRaceLength(race: Race | undefined): string {
    let raceAltitude: string;
    if (race?.minAltitude && race?.maxAltitude) {
      raceAltitude = race!.minAltitude + "m" + ' / ' + race!.maxAltitude + "m";
    } else if (race?.minAltitude && (race?.maxAltitude === undefined || race?.maxAltitude === null)) {
      raceAltitude = "" + race?.minAltitude + "m";
    } else if (race?.maxAltitude && (race?.minAltitude === undefined || race?.minAltitude === null)) {
      raceAltitude = "" + race?.maxAltitude + "m";
    } else {
      raceAltitude = '-';
    }
    return raceAltitude;
  }
}
